import styled from '@emotion/styled';

export const StyledLabel = styled.label<{ disabled?: boolean }>`
    margin-bottom: 10px;
    color: ${({ theme }) => theme.color.black200};
    display: block;
    ${({ theme }) => theme.font.caption.bold}
    ${({ disabled }) => disabled && `opacity: 0.5;`}
`;
